export const getAssociateIds = (
    suggestedDriversAssociateId: number[],
): string => {
    if (suggestedDriversAssociateId.length > 0) {
        return `and (not (AssociateId in (${suggestedDriversAssociateId})))`;
    }

    return '';
};
